import { motion } from "framer-motion";
import { IMAGES } from "../../lib/content";
import { Reveal } from "../Reveal";

const EASE = [0.16, 1, 0.3, 1];

const PEPEHA = [
  "Tēnā koutou.",
  "E noho ana au ki Ōtautahi.",
  "Ko tēnei taku mihi ki ngā tangata whenua o tēnei wāhi —",
  "ko Aoraki te maunga,",
  "ko Waimakariri te awa,",
  "ko Ngāi Tahu te iwi.",
  "__break__",
  "Ko Pirongia tōku maunga,",
  "ko Waipā tōku awa,",
  "ko Tainui tōku waka,",
  "ko Ngāti Maniapoto tōku iwi,",
  "ko Ngāti Kaputuhi tōku hapū,",
  "ko Kaputuhi tōku marae.",
  "Nō reira, tēnā koutou katoa.",
];

const LETTER = [
  "Ngā Kākano Wāhine did not begin with a business plan. It began with a belief.",
  "A belief that potential already exists. A belief that opportunity should never be determined by someone's hardest chapter.",
  "I know how easily a life can be written off. I met the justice system at 13, and I was in and out of prison until I was 27. That is not the focus of this kaupapa — but it is the reason I believe in it so completely.",
  "I have seen what happens when a person is judged by their worst moment. And I have felt what changes when someone believes in who you could become.",
  "Ngā Kākano Wāhine exists to offer that belief to wāhine — through business, education, mentoring and rongoā — so they can rediscover the mana that was always theirs.",
];

export const Founder = () => {
  return (
    <section
      id="founder"
      data-testid="founder-section"
      className="relative bg-earth text-cream py-32 sm:py-40 lg:py-48 overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
        {/* Portrait + pepeha */}
        <Reveal className="lg:sticky lg:top-28">
          <div className="relative aspect-[4/5] overflow-hidden max-w-md">
            <motion.img
              src={IMAGES.founder}
              alt="Sonni Leigh Newton, Founder of Ngā Kākano Wāhine"
              initial={{ scale: 1.1 }}
              whileInView={{ scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1.6, ease: EASE }}
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-gold/30" />
          </div>
          <div className="mt-10 space-y-1.5 text-cream/80 font-light text-base italic leading-relaxed max-w-md">
            {PEPEHA.map((line, i) =>
              line === "__break__" ? (
                <div key={i} className="h-4" />
              ) : (
                <p key={i} className={line === "Nō reira, tēnā koutou katoa." ? "not-italic pt-2 text-cream/90" : ""}>
                  {line}
                </p>
              )
            )}
          </div>
        </Reveal>

        {/* Letter */}
        <div>
          <Reveal>
            <p className="overline text-gold mb-8">Te Reta a te Kaiwhakarewa · A Founder’s Letter</p>
          </Reveal>
          <div className="space-y-7 text-cream/85 font-light text-lg sm:text-xl leading-relaxed">
            {LETTER.map((p, i) => (
              <Reveal key={i} delay={i * 0.04} y={30}>
                <p className={i === 0 ? "font-serif-display text-2xl sm:text-3xl text-cream leading-snug" : ""}>
                  {p}
                </p>
              </Reveal>
            ))}
          </div>

          <Reveal className="mt-14" y={30}>
            <p className="font-serif-display text-3xl sm:text-4xl font-light leading-[1.15]">
              This is only the first seed.
              <br />
              <span className="text-gold italic">The forest will be grown together.</span>
            </p>
          </Reveal>

          <Reveal className="mt-12" y={20}>
            <p className="font-serif-display text-2xl italic text-cream">Sonni Leigh Newton</p>
            <p className="mt-1 overline text-gold">Founder — Ngā Kākano Wāhine</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
